import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { Icon } from '@unmind/design-system';
import { BodyText, HeadingText } from '../../../Shared/Typography';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const PageTitle = styled(HeadingText).attrs(({ theme }) => ({
  level: 1,
  sizes: [
    theme.typography.fontSizes.fontSize28,
    theme.typography.fontSizes.fontSize32,
  ],
  weight: theme.typography.fontWeights.semiBold,
  align: 'center',
}))`
  justify-content: center;
  align-items: center;
  display: flex;
  padding-top: ${rem(12)};
`;

const PageDescription = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize20],
  weight: theme.typography.fontWeights.regular,
  color: theme.colors.text.secondary,
  align: 'center',
}))`
  margin-top: ${rem(8)};
`;

interface Wrapper404Props {
  title: string;
  description: string;
}

const Wrapper404: React.FC<Wrapper404Props> = ({
  title,
  description,
  children,
}) => (
  <PageContainer>
    <Icon
      icon="window-search"
      size="extra-large"
      tone="subtle"
      style={{ width: '48px', height: '48px' }}
    />
    <PageTitle>{title}</PageTitle>
    <PageDescription>{description}</PageDescription>
    {children}
  </PageContainer>
);

export default Wrapper404;
